import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import axios from "axios";
import { useParams } from "react-router-dom";
import { nftInfo } from "../NftMarketPage/contractData";
import { ethers } from "ethers";
import {
  // nftContractABI,
  metaspaceNFTMarketplaceAddress,
  metaspaceNFTMarketplaceABI,
} from "../../../config/data";
import NftMarketHomepage from "../NftMarketPage/NftMarketHomepage";
import BackgroundBanner from "./BackgroundBanner";
import NftBidingDetailpage from "./NftBidingDetailpage";
import SpecificNftDescription from "./SpecificNftDescription";
import environmentVariables from "../../../config/environmentVariables";
// import BuyNow from "../BuyNowPopUp/BuyNow";
import ActivityTableComponent from "./ActivityTableComponent";
import ActivityTableGraph from "./ActivityTableGraph";
import { getEthersProvider } from "../../../utils/rpcProvider";
// import MoreCollectionSpecific from "./MoreCollectionSpecific";
// import PistolComponent from "./PistolComponent";
// import PistolDescriptionComponent from "./PistolDescriptionComponent";
// import SpecificGraphComponent from "./SpecificGraphComponent";

const Root = styled.div``;
const Container = styled.div`
  /* position: "relative"; */
  display: flex;
  flex-direction: column;

  /* margin-bottom: 50px; */
`;
const NftBidingSpecificWrapper = styled.div`
  margin: 0 40px;
  width: 50%;
  @media (max-width: 1740px) {
    margin: 0 0 0 20px;
  }
  @media (max-width: 1440px) {
    margin: 0 0 0 20px;
  }
  @media (max-width: 1100px) {
    margin: 30px 0 0 0 !important;
    width: 100%;
  }
`;

const NftMarketContainer = styled.div`
  display: block;
  justify-content: space-between;
  padding-bottom: 5rem;
  /* position: absolute; */
  width: 91%;
  z-index: 10;
  padding: 0 2rem;
  @media (max-width: 1440px) {
    padding: 20px 0.2rem 0;
    width: 100%;
  }
  @media (max-width: 1740px) {
    /* padding: 20px 5.5rem 0; */
    width: 100%;
  }
  @media (max-width: 1100px) {
    z-index: 1;
  }
  @media (max-width: 1024px) {
    padding: 0 20px;
    width: 100%;
    display: flex;
    /* justify-content: center; */
  }

  @media (max-width: 768px) {
    padding: 0rem;
    width: 88%;
  }
`;

const BackgroundBannerWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  border: 1px solid #1f2426;
  border-radius: 20px;
  @media (max-width: 768px) {
    height: 500px;
  }
`;
const GraphHeading = styled.div`
  padding: 30px 0;
  font-family: "Lato";
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  font-size: 24px;
`;
const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  padding: 0 2rem;
  margin: 80px 0;
  @media (max-width: 1740px) {
    margin-top: 40px;
  }
  @media (max-width: 1440px) {
    padding: 0 20px;
    margin-top: 40px;
  }
  @media (max-width: 1100px) {
    flex-direction: column;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    margin-bottom: 20px;
  }
`;
const ModalGraph = styled.div`
  width: 50%;
  @media (max-width: 1100px) {
    width: 100%;
  }
`;

const BackButton = styled.button`
  padding: 8px 16px;
  background-color: #267383;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  z-index: 5;
  display: inline-block;
  width: auto;
  margin-bottom: 20px;

  /* Default center alignment */
  margin-left: auto;
  margin-right: auto;

  &:hover {
    background-color: #1f5a63;
  }

  /* Responsive fixes */
  @media (max-width: 1440px) and (min-width: 1024px) {
    margin-left: 20px; /* small left offset from sidebar */
  }

  @media (max-width: 1024px) and (min-width: 768px) {
    margin-left: 10px;
    margin-bottom: 10px;
  }

  @media (max-width: 768px) {
    margin-left: 20px; /* small padding on mobile */
    margin-bottom: 0px;
  }
`;

const Nftspecifichomepage = ({ allContractDetails, setAllContractDetails }) => {
  const navigate = useNavigate();
  const params = useParams();
  const [detailOfNft, setDetailOfNft] = useState({});
  const [tradeList, setTradeList] = useState({});
  const [detailOfNftCentral, setDetailOfNftCentral] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingActivityAndHistory, setLoadingActivityAndHistory] =
    useState(false);
  useEffect(() => {
    if (params?.contract && params?.tokenId) {
      fetchFeaturedData(params.contract, params.tokenId);
      const trade = fetchNewArrivalData(params.contract, params.tokenId);
      setTradeList(trade);
    }
  }, []);
  useEffect(() => {
    if (params?.contract && params?.tokenId) {
      fetchData();
      // console.log(params?.contract, params?.tokenId);
      fetchNftDetail(
        params?.contract,
        params?.tokenId,
        `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get_token_details/`
      )
        .then((res) => {
          setDetailOfNftCentral(res);
          setLoading(false);
        })
        .catch((err) => console.log(err));
    }
    // console.log(detailOfNft, "details");
  }, []);

  useEffect(() => {
    if (allContractDetails) {
      // fetchData();
    }
  }, [allContractDetails]);

  const fetchData = async () => {
    if (params?.contract && params?.tokenId) {
      try {
        setLoadingActivityAndHistory(true);
        fetchFeaturedData(params.contract, params.tokenId);
        const trade = await fetchNewArrivalData(
          params.contract,
          params.tokenId
        );
        setTradeList(trade);
        setLoadingActivityAndHistory(false);
        // console.log(trade, params?.contract, params?.tokenId, "tradelistnft");
      } catch (err) {
        console.log(err);
      }
    }
  };

  const fetchNftDetail = async (address, index, url) => {
    const response = await axios.get(`${url}${address}/${index}`);
    // console.log(response?.data,'lllllllllllllllllllllllllllllllllllll')
    return response.data;
  };

  const fetchFeaturedData = async (contract, i) => {
    if (allContractDetails) {
      try {
        let obj = {};

        // const metaspaceBaseApiURL = await getMetaspaceBaseApiURL(allContractDetails?.nftStakingContract)
        const metaspaceBaseApiURL = `${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get_token_details/`;

        await nftInfo(
          allContractDetails?.metaspaceNFTMarketplaceContract,
          contract.toLowerCase(),
          i
        )
          .then(async (nftContractInfo) => {
            // console.log("nftContractInfo", nftContractInfo);
            if (Number(nftContractInfo.listingStage) !== 0) {
              const nftDetail = await fetchNftDetail(
                contract.toLowerCase(),
                i,
                metaspaceBaseApiURL
              );
              obj = {
                ...obj,
                contract,
                fetchDetails: nftDetail,
                data: nftContractInfo,
              };

              setDetailOfNft({ ...obj });
            } else {
              obj = {
                ...obj,
                contract,
                data: nftContractInfo,
              };

              setDetailOfNft({ ...obj });
            }
          })
          .catch((err) => {
            console.log("errinsideanftInfo", err);
          });
      } catch (err) {
        console.log("err", err);
      }
    }
  };

  const fetchNewArrivalData = async (contractId, i) => {
    // const metaspaceNFTMarketplaceContract = await getMetaspaceNFTMarketplaceContract();

    const provider = getEthersProvider() || new ethers.JsonRpcProvider(
      "https://polygon-mainnet.infura.io/v3/8cc9a225361c451e9594fd5409930f6f"
    );
    const fromBlock = 36767745;

    const contract = new ethers.Contract(
      metaspaceNFTMarketplaceAddress,
      metaspaceNFTMarketplaceABI,
      provider
    );

    const filter = contract.filters.NFTtraded(contractId, i);

    const a = await contract.queryFilter(filter, fromBlock, "latest");

    return a;
  };
  // console.log("detailOfNftCentral", detailOfNftCentral);

  return (
    <Root>
      <Container>
        <NftMarketContainer>
          <BackButton onClick={() => navigate(-1)}>← Go Back</BackButton>
          <NftMarketHomepage allContractDetails={allContractDetails} />
        </NftMarketContainer>
        <Wrapper>
          <ModalGraph>
            <BackgroundBannerWrapper>
              <BackgroundBanner contractAddress={params?.contract} detailOfNftCentral={detailOfNftCentral} />
            </BackgroundBannerWrapper>
            {tradeList && tradeList.length > 0 && (
              <div>
                <GraphHeading>NFT Listing Price</GraphHeading>

                <ActivityTableGraph nftData={tradeList} />
              </div>
            )}
          </ModalGraph>
          <NftBidingSpecificWrapper className="col-md-6">
            <NftBidingDetailpage
              nftLoading={loading}
              setAllContractDetails={setAllContractDetails}
              allContractDetails={allContractDetails}
              data={detailOfNftCentral}
              setDetailOfNftCentral={setDetailOfNftCentral}
              rarity={
                detailOfNft?.fetchDetails?.category ||
                detailOfNftCentral?.category ||
                ""
              }
              name={detailOfNft?.fetchDetails?.name || detailOfNftCentral?.name}
              fetchDetails={
                detailOfNft?.fetchDetails || detailOfNftCentral || {}
              }
            />
            <SpecificNftDescription
              loading={loading}
              data={detailOfNft?.data || detailOfNftCentral}
              fetchDetails={
                detailOfNft?.fetchDetails || detailOfNftCentral || {}
              }
            />
          </NftBidingSpecificWrapper>
        </Wrapper>
        <ActivityTableComponent
          loadingActivityAndHistory={loadingActivityAndHistory}
          tradeList={tradeList}
        />
      </Container>
    </Root>
  );
};

export default Nftspecifichomepage;
